/* eslint-disable react-hooks/exhaustive-deps */
import {
  Modal,
  Input,
  Select,
  DatePicker,
  Form,
  Switch,
  Skeleton,
  Row,
  Col,
  Tabs,
} from "antd";
import { useState, React, useEffect } from "react";
import { Radio } from "antd";
import { ufs } from "../../Constante/UFS";
import CartorioRequest from "./CartorioRequest";
import SelEmolumentoPeriodo from "../../Selecao/EmolumentoPeriodo/Sel_EmolumentoPeriodo";
import moment from "moment";
import { useUserContext } from "../../contexts/usersContext";
import { ModalStatusCreate, ModalStatusEdit } from "../../Utils/modalStatus";

const { useForm } = Form;

function CadastroCartorio({ visible, onCancel, estadoCartorio, id }) {
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalEmolumentoPeriodoVisible, setIsModalEmolumentoPeriodoVisible] =
    useState(false);
  const [openModalStatus, setOpenModalStatus] = useState({
    create: false,
    edit: false,
  });

  const [provimento, setProvimento] = useState([
    { id: null, descricao: "", situacao: "" },
  ]);

  const [timezones, setTimezones] = useState([]);

  const [form] = useForm();

  const { currentUser } = useUserContext();

  useEffect(() => {
    if (id) {
      getCartorioId();
    }
  }, [id]);

  useEffect(() => {
    if (visible) {
      getProvimento74();
      getTimezones();
    }
  }, [visible]);

  const options = ufs.map((uf) => {
    return {
      label: uf.nome,
      value: uf.sigla,
    };
  });

  async function CadastrarCartorio(cartorio) {
    try {
      const response = await CartorioRequest.CadastrarCartorio(cartorio, id);

      if (response.status === 201) {
        form.resetFields();
        setConfirmLoading(false);
        onCancel();
        estadoCartorio((prevCartorio) => [response.data, ...prevCartorio]);
        setOpenModalStatus((prevState) => ({ ...prevState, create: true }));
      }
      if (response.status === 200) {
        form.resetFields();
        setConfirmLoading(false);
        onCancel();
        const cb = (callback) => {
          if (callback.id === id) {
            return { ...callback, ...response.data };
          } else {
            return { ...callback };
          }
        };
        estadoCartorio((prevState) => prevState.map(cb));
        setOpenModalStatus((prevState) => ({ ...prevState, edit: true }));
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setConfirmLoading(true);
        CadastrarCartorio(
          values.usa_ip_fixo ? values : { ...values, ip_fixo: null },
        );
      })
      .catch((info) => {
        console.error("erro:", info);
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  function onSelecionarEmolumentoPeriodo(valor) {
    setIsModalEmolumentoPeriodoVisible(false);
    form.setFieldsValue({
      emolumento_periodo_id: valor.id,
      emolumento_periodo_descricao: valor.descricao,
    });
  }

  const getCartorioId = async () => {
    setLoading(true);
    try {
      const response = await CartorioRequest.getCartorio(id);
      if (response.status === 200 || response.status === 201) {
        const { data } = response;

        form.setFieldsValue({
          nome_cartorio: data.nome_cartorio,
          uf: data.uf,
          qtde_licenca: data.qtde_licenca,
          situacao: data.situacao,
          usa_os: data.usa_os,
          usa_pix: data.usa_pix,
          bloqueio: data.bloqueio,
          usa_api: data.usa_api,
          usa_whatszap: data.usa_whatszap,
          emolumento_periodo_descricao: data.emolumento_periodo_descricao,
          emolumento_periodo: data.emolumento_periodo,
          dia_vencimento: data.dia_vencimento,
          data_vencimento: data.data_vencimento
            ? moment(data.data_vencimento)
            : undefined,
          data_liberacao: data.data_liberacao
            ? moment(data.data_liberacao)
            : undefined,
          data_implantacao: data.data_implantacao
            ? moment(data.data_implantacao)
            : undefined,
          data_bloqueio: data.data_bloqueio
            ? moment(data.data_bloqueio)
            : undefined,
          data_atualizacao: data.data_atualizacao
            ? moment(data.data_atualizacao)
            : undefined,
          atualizar_emolumento: data.atualizar_emolumento,
          cpfcnpj: data.cpfcnpj,
          cidade: data.cidade,
          usa_cad_ato: data.usa_cad_ato,
          em_aberto: data.em_aberto,
          chave: data.chave,
          atualizar_com_erro: data.atualizar_com_erro,
          bloquear_atualizacao: data.bloquear_atualizacao,
          usa_bi: data.usa_bi,
          usa_workflow: data.usa_workflow,
          usa_gsti: data.usa_gsti,
          cns: data.cns,
          situacao_serventia: data.situacao_serventia,
          versao_banco: data.versao_banco,
          provimento74_id: data.provimento74_id,
          latitude: data.latitude,
          longitude: data.longitude,
          horario_expediente_ini: data.horario_expediente_ini,
          horario_expediente_fim: data.horario_expediente_fim,
          expediente_tempo_almoco: data.expediente_tempo_almoco,
          expediente_timezone: data.expediente_timezone,
          ip_fixo: data.ip_fixo,
          usa_ip_fixo: data.usa_ip_fixo,
          emissor_nfse: data.emissor_nfse,
        });
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getProvimento74 = async () => {
    const response = await CartorioRequest.getProvimento74();
    if (response.status === 200) {
      const { results } = response.data;
      setProvimento(results);
    }
  };

  const optionsProvimento = provimento.map((item) => ({
    value: item.id,
    label: item.descricao,
  }));

  const getTimezones = async () => {
    const response = await CartorioRequest.timezones();

    if (response.status === 200) {
      setTimezones(response.data);
    }
  };

  const optionsTimezones = timezones.map((item) => ({
    value: item,
    label: item,
  }));

  const optionsEmissorNF = [
    { value: "NE", label: "Não Emitindo" },
    { value: "EL", label: "Emissor Local" },
    { value: "EN", label: "Emissor Nacional" },
  ];

  const { TabPane } = Tabs;

  const ip_fixo = Form.useWatch("usa_ip_fixo", form);

  const formatIP = (value) => {
    let digits = value.replace(/\D/g, "");

    if (digits.length <= 6) {
      return digits
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{1})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{1})\.(\d{1})(\d)/, "$1.$2.$3.$4");
    }

    if (digits.length <= 8) {
      return digits
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{3}).(\d{1})(\d)/, "$1.$2.$3.$4")
        .replace(/^(\d{3})\.(\d{3}).(\d{1})\.(\d{3})(\d)/, "$1.$2.$3.$4.$5");
    }
    if (digits.length <= 10) {
      return digits
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{3})\.(\d{1})(\d)/, "$1.$2.$3.$4")
        .replace(/^(\d{3})\.(\d{3})\.(\d{1})\.(\d{3})(\d)/, "$1.$2.$3.$4.$5");
    }

    if (digits.length <= 11) {
      return digits
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{3})\.(\d{2})(\d)/, "$1.$2.$3.$4");
    }

    return digits.match(/\d{1,3}/g)?.join(".") || "";
  };

  const isValidIP = (value) => {
    const octets = value.split(".");
    if (octets.length !== 4) return false;

    for (let octet of octets) {
      if (!/^\d+$/.test(octet)) return false;
      const num = parseInt(octet, 10);
      if (num < 0 || num > 255) return false;
    }

    return true;
  };

  return (
    <>
      <Modal
        width={780}
        title={id ? "Editar" : "Cadastro"}
        visible={visible}
        onOk={handleOk}
        onCancel={onCancel}
        destroyOnClose={true}
        confirmLoading={confirmLoading}
        okButtonProps={{
          disabled:
            !currentUser.is_superuser &&
            !currentUser.is_manager &&
            !currentUser.is_financial &&
            !currentUser.is_staff,
        }}
      >
        {loading ? (
          <Skeleton />
        ) : (
          <Form
            form={form}
            layout="vertical"
            preserve={false}
            disabled={
              !currentUser.is_superuser &&
              !currentUser.is_manager &&
              !currentUser.is_financial &&
              !currentUser.is_staff
            }
          >
            <Tabs>
              <TabPane tab="Dados Cartório" key={1}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item name="id" style={{ display: "none" }} />
                  <Form.Item
                    name="nome_cartorio"
                    label="Nome cartório:"
                    rules={[
                      {
                        required: true,
                        message: "Informe o nome do cartorio",
                      },
                    ]}
                    style={{ marginBottom: 10, width: "77.6%" }}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="cpfcnpj"
                    label="CPF/CNPJ:"
                    style={{ marginBottom: 10, width: "18%" }}
                  >
                    <Input maxLength={14} />
                  </Form.Item>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Form.Item
                    name="cidade"
                    label="Cidade:"
                    rules={[
                      {
                        required: true,
                        message: "Informe a cidade",
                      },
                    ]}
                    style={{ marginBottom: 10, width: "77.6%" }}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="uf"
                    label="UF:"
                    rules={[
                      {
                        required: true,
                        message: "Informe a UF",
                      },
                    ]}
                    style={{
                      marginBottom: 10,
                      width: "18%",
                    }}
                  >
                    <Select name="uf" options={options} />
                  </Form.Item>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 16,
                  }}
                >
                  <Form.Item
                    label="Longitude:"
                    name="longitude"
                    rules={[
                      {
                        validator: (_, value) => {
                          const number = parseFloat(value);
                          if (isNaN(number)) {
                            return Promise.reject(
                              new Error("Informe um número válido."),
                            );
                          }
                          if (number > 90) {
                            return Promise.reject(
                              new Error(
                                "Certifique-se de que este valor seja inferior ou igual a 90.",
                              ),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Latítude:"
                    name="latitude"
                    rules={[
                      {
                        validator: (_, value) => {
                          const number = parseFloat(value);
                          if (isNaN(number)) {
                            return Promise.reject(
                              new Error("Informe um número válido."),
                            );
                          }
                          if (number > 90) {
                            return Promise.reject(
                              new Error(
                                "Certifique-se de que este valor seja inferior ou igual a 90.",
                              ),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Expediente Início:"
                    name="horario_expediente_ini"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          const regex =
                            /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                          if (!regex.test(value)) {
                            return Promise.reject(
                              new Error(
                                "Formato inválido para Tempo. Use hh:mm:ss.",
                              ),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input placeholder="hh:mm:ss" />
                  </Form.Item>
                  <Form.Item
                    label="Expediente Fim:"
                    name="horario_expediente_fim"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          const regex =
                            /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                          if (!regex.test(value)) {
                            return Promise.reject(
                              new Error(
                                "Formato inválido para Tempo. Use hh:mm:ss.",
                              ),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input placeholder="hh:mm:ss" />
                  </Form.Item>
                </div>

                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Form.Item
                    name="qtde_licenca"
                    label="Qtd licença:"
                    rules={[
                      {
                        required: true,
                        message: "Informe a quantidade de licença",
                      },
                    ]}
                    style={{ marginBottom: 10, width: 171 }}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="data_implantacao"
                    label="Data implantação:"
                    style={{ marginBottom: 10, width: 171 }}
                  >
                    <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                  </Form.Item>

                  <Form.Item name="cns" label="CNS:" style={{ width: 171 }}>
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="versao_banco"
                    label="Versão DB:"
                    style={{ width: 171 }}
                  >
                    <Select
                      options={[
                        { value: "FB25", label: "Firebird 2.5" },
                        { value: "FB30", label: "Firebird 3.0" },
                        { value: "FB50", label: "Firebird 5.0" },
                      ]}
                    />
                  </Form.Item>
                </div>

                <div style={{ display: "flex", gap: 16 }}>
                  <Form.Item
                    label="Tempo de Almoço:"
                    name="expediente_tempo_almoco"
                    help="Informe o tempo em minutos"
                    style={{ width: "100%" }}
                  >
                    <Input type="number" placeholder="Ex: 60" />
                  </Form.Item>
                  <Form.Item
                    name="expediente_timezone"
                    label="Timezone:"
                    style={{ width: "100%" }}
                  >
                    <Select options={optionsTimezones} />
                  </Form.Item>

                  <Form.Item
                    name="emissor_nfse"
                    label="Emissor NFS-e:"
                    style={{ width: "100%" }}
                  >
                    <Select options={optionsEmissorNF} />
                  </Form.Item>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Form.Item
                      name="provimento74_id"
                      label="Provimento 213"
                      rules={[
                        {
                          required: true,
                          message: "Este campo é obrigatório.",
                        },
                      ]}
                    >
                      <Select options={optionsProvimento} />
                    </Form.Item>

                    <Form.Item
                      name="situacao"
                      label="Situação:"
                      rules={[
                        {
                          required: true,
                          message: "Informe a situação",
                        },
                      ]}
                    >
                      <Radio.Group>
                        <Radio value={"A"}>Ativo</Radio>
                        <Radio value={"I"}>Inativo</Radio>
                      </Radio.Group>
                    </Form.Item>

                    <Form.Item
                      name="situacao_serventia"
                      label="Situação Serventia:"
                    >
                      <Radio.Group>
                        <Radio value={"P"}>Provido</Radio>
                        <Radio value={"V"}>Vago</Radio>
                      </Radio.Group>
                    </Form.Item>

                    <Form.Item name="bloqueio" label="Bloqueio">
                      <Radio.Group>
                        <Radio value={true}>Ativo</Radio>
                        <Radio value={false}>Inativo</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
              </TabPane>

              <TabPane tab="Configurações de Uso" key={2}>
                <Row justify="space-between">
                  <Col>
                    {currentUser.is_superuser ||
                    currentUser.is_manager ||
                    currentUser.is_staff ? (
                      <Form.Item
                        name="bloquear_atualizacao"
                        label="Bloquear atualização:"
                        valuePropName="checked"
                      >
                        <Switch
                          checkedChildren={true}
                          unCheckedChildren={false}
                        />
                      </Form.Item>
                    ) : null}

                    <Form.Item
                      valuePropName="checked"
                      label="Atualizar com erro:"
                      name="atualizar_com_erro"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="em_aberto"
                      label="Em Aberto:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>
                  </Col>

                  <Col>
                    <Form.Item
                      name="usa_cad_ato"
                      label="Usa Cadastro Ato:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="atualizar_emolumento"
                      label="Atualizar Emol.:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="usa_workflow"
                      label="Usa Workflow:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>
                  </Col>

                  <Col>
                    <Form.Item
                      name="usa_whatszap"
                      label="Usa WhatsZap:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="usa_bi"
                      label="Usa BI:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="usa_os"
                      label="Usa OS:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>
                  </Col>

                  <Col>
                    <Form.Item
                      name="usa_pix"
                      label="Usa PIX:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>

                    <Form.Item
                      name="usa_api"
                      label="Usa api:"
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>
                  </Col>

                  <div
                    style={{
                      width: "100%",
                      minWidth: 260,
                      padding: "12px 16px",
                      border: "1px solid #d9d9d9",
                      borderRadius: 10,
                      background: ip_fixo ? "#fafafa" : "#fff",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Form.Item
                      name="usa_ip_fixo"
                      label="Usa IP Fixo:"
                      valuePropName="checked"
                      style={{ marginBottom: ip_fixo ? 8 : 0 }}
                    >
                      <Switch
                        checkedChildren={true}
                        unCheckedChildren={false}
                      />
                    </Form.Item>
                    {ip_fixo && (
                      <Form.Item
                        name="ip_fixo"
                        label="IP Fixo:"
                        extra="Informe um endereço de IP"
                        style={{ marginBottom: 0 }}
                        getValueFromEvent={(e) => formatIP(e.target.value)}
                        rules={[
                          {
                            validator: (_, value) =>
                              !value || isValidIP(value)
                                ? Promise.resolve()
                                : Promise.reject(new Error("IP inválido")),
                          },
                        ]}
                      >
                        <Input placeholder="Ex: 192.168.0.10" />
                      </Form.Item>
                    )}
                  </div>
                </Row>
              </TabPane>
            </Tabs>
          </Form>
        )}
        <SelEmolumentoPeriodo
          onSelecionado={(valor) => {
            onSelecionarEmolumentoPeriodo(valor);
          }}
          visible={isModalEmolumentoPeriodoVisible}
          onCancel={() => setIsModalEmolumentoPeriodoVisible(false)}
          optionsUf={options}
        />
      </Modal>

      <ModalStatusCreate
        onCancel={() =>
          setOpenModalStatus((prevState) => ({ ...prevState, create: false }))
        }
        visible={openModalStatus.create}
      />
      <ModalStatusEdit
        onCancel={() =>
          setOpenModalStatus((prevState) => ({ ...prevState, edit: false }))
        }
        visible={openModalStatus.edit}
      />
    </>
  );
}

export default CadastroCartorio;
